<template>
  <div class="modal-dialog">
    <div class="modal_content login_extension_wrap">
      <!-- contents -->
      <div class="modal_header">
        <h5 style="color:red;">{{ $t('cop.pm.title') }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')" />
      </div>
      <div class="modal_body">
        <div class="extension_wrap">
          <div class="time">
            <p>
              <strong>{{ remainMin }}</strong><span>{{ $t('cop.login-extension.minute') }}</span>
              <strong>{{ remainSec }}</strong><span>{{ $t('cop.login-extension.second') }}</span>
            </p>
            <p>
              {{ $t('cop.pm.message.progress-bar') }}
            </p>
          </div>
          <div class="ext_prog"><span :style="{ width:`${100-remainTime/6000}%` }"></span></div>
          <div class="ext_msg" v-html=" $t('cop.pm.message.information')">
          </div>
        </div>
      </div>
      <div class="modal_footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.confirm') }}
        </button>
      </div>
    </div>
    <!-- // contents -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      now: Date.now(),
    };
  },
  computed: {
    ...mapGetters({
      lastMaintenance: 'getMaintenance',
    }),
    remainTime() {
      return this.lastMaintenance.fromPeriod - this.now;
    },
    remainSec() {
      return Math.floor((this.remainTime / 1000) % 60);
    },
    remainMin() {
      return Math.floor((this.remainTime / 1000) / 60);
    },
  },
  watch: {
    remainTime() {
      if (this.remainTime < 0) {
        this.$router.push(`${this.$context}/`);
        this.$emit('close');
      }
    },
  },
  created() {
    setInterval(() => {
      this.now = Date.now();
    }, 1000);
  },
  mounted() {
    this.maintenanceStart = this.lastMaintenance.fromPeriod;
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/common/popup/MaintenanceAlertPopup.vue